module.exports = __webpack_public_path__ + "files/ba0613ccc07e5e156e089bfb3f71771a.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/food_drink-2.png
// module id = 512
// module chunks = 76